export default "__VITE_ASSET__CZU8WaCH__"